import moment from "moment";
import axios from "axios";
import _ from "lodash";

import apiUrl from "api-url";
import buildFetchDuck from "vendor/signal-utils/build-fetch-duck";
import buildSearchBarState from "components/search-bar/SearchBarStateBuilder";
import { PaginationType } from "components/search-bar/enums.utils";
import {
  SEARCH_CATEGORIES,
  FILTERS,
} from "pages/partview/components/search/PartView.searchOptions";
import { updatedWatchedPackages } from "pages/partview/utils/watchedPackageUtils";
import { transformSearchResponse } from "../utils/transformSearchResponse";

const STORE_MOUNT_POINT = "partViewSearch";

const watchedPackageListDuck = buildFetchDuck(
  STORE_MOUNT_POINT,
  "watchedPackageList",
);

// SearchBarStateBuilder need 'solutionId' as first parameter,
// but not required in entitiesUrl, batchSearchUrl therefore named it _ignored_solutionId
const entitiesUrl = (_ignored_solutionId, queryString) => {
  return apiUrl(`/partview/app/opensearch/search?status=active&${queryString}`);
};

const batchSearchUrl = (_ignored_solutionId, queryString, batchType) => {
  return apiUrl(
    `/partview/app/opensearch/search?status=active&${queryString}&batchType=${batchType}`,
  );
};

const axiosConfig = () => {
  return {
    headers: {
      "x-time-zone": moment.tz.guess(),
      Accept: "application/json;",
    },
  };
};

const fetchWatchedPackageIDs = () => (dispatch) => {
  let url = apiUrl(`partview/app/package-container-watch`);
  dispatch(watchedPackageListDuck.fetch(url));
};

const fetchSearch = (
  queryString = "",
  _ignored_solutionId,
  duck,
  dispatch,
  state,
  preventRedirect,
) => {
  const batchFilter = state[STORE_MOUNT_POINT].searchFilters.batch;

  if (batchFilter) {
    // Batch search POST
    batchSearch(_ignored_solutionId, queryString, dispatch, batchFilter, duck);
  } else {
    const url = entitiesUrl(null, queryString);
    const config = axiosConfig();

    // Fetch the search
    dispatch(duck.fetch(url, config, transformSearchResponse));

    dispatch(fetchWatchedPackageIDs());

    // Prevent redirect if needed
    if (!preventRedirect) {
      dispatch({ type: "PARTVIEW_SEARCH" });
    }
  }
};

const batchSearch = (
  _ignored_solutionId,
  queryString,
  dispatch,
  batchFilter,
  duck,
) => {
  const batchValueArray = batchFilter.batch_list;
  const batchType = batchFilter.batch_type;
  const url = batchSearchUrl(_ignored_solutionId, queryString, batchType);
  const data = {
    batch_list: batchValueArray,
  };
  const config = axiosConfig();

  dispatch({
    type: duck.actions.REQUEST,
  });

  axios
    .post(url, data, config)
    .then((response) => {
      dispatch({
        type: duck.actions.RECEIVE,
        payload: response.data ? transformSearchResponse(response.data) : [],
      });

      dispatch({ type: "PARTVIEW_SEARCH" });
    })
    .catch((err) => {
      dispatch({
        type: duck.actions.REQUEST_ERROR,
        err,
      });
    });
};

//selectors
const getWatchedSearchResults = (state) => {
  const searchWatchedPackage = state[STORE_MOUNT_POINT]?.data?.data;
  const duckState =
    watchedPackageListDuck.selectors.getData(state)?.data
      ?.userWatchedContainerIds;
  const result = updatedWatchedPackages(searchWatchedPackage, duckState);
  return result ?? [];
};

const SearchBarState = buildSearchBarState(
  STORE_MOUNT_POINT,
  SEARCH_CATEGORIES,
  FILTERS,
  fetchSearch,
  [watchedPackageListDuck.reducer],
  { defaultSort: "destinationEta", reverseSort: false },
  20,
  PaginationType.OPEN_SEARCH,
);

SearchBarState.actionCreators.exportSearch = _.partial(
  SearchBarState.actionCreators.exportEntities,
  entitiesUrl,
  batchSearchUrl,
  { headers: { Accept: "text/csv;version=full" } },
  "part-view-search-results",
);

SearchBarState.selectors = {
  ...SearchBarState.selectors,
  getWatchedSearchResults,
};

export default SearchBarState;
